import NavLink from '../NavLink';
import { Wrapper } from './styles';
import { user_roles } from "../../config/enums";
import { useUser } from "../../context/user";
import { useIdCatalogSearch } from '../SideMenuSearchLane/context';

const navLinks = [
  // {
  //   label: 'Catalog',
  //   to: '/catalog',
  // },
  {
    label: 'Project list',
    to: '/projects',
    roles: [user_roles.viewer, user_roles.admin, user_roles.castAdmin, user_roles.projectAdmin],
  },
  {
    label: 'Standardization projects',
    to: '/standardization',
    roles: [user_roles.admin, user_roles.castAdmin, user_roles.stAdmin, user_roles.stFraming, user_roles.stProject, user_roles.stViewer],
  },
  // {
  //   label: 'Business dev',
  //   to: '/business-dev',
  // },
];

const NavigationBar = () => {
  const { user } = useUser();
  const { setIsSideMenuCollapsed } =
      useIdCatalogSearch();

  const clickMenuItem = () => {
    setIsSideMenuCollapsed(true);
  };

  return (
    <Wrapper>
      {navLinks.map(({ label, to, roles }) => {
        if (user?.roles.some(r => roles.includes(r)))
        return <NavLink to={to} key={to} onClick={clickMenuItem}>{label}</NavLink>;
        else return null;
      })}
    </Wrapper>
  );
};

export default NavigationBar;
